import { userTypes } from "./userTypes"

export const getIsShopper = (currentUser) => {
    if (!currentUser) return null;
    return currentUser.attributes?.profile?.protectedData?.userType === userTypes.shopper ||
        currentUser.attributes?.profile?.protectedData?.userType === userTypes.shopsAndBrandsAndShopper;
}

export const getIsOnlyShopper = (currentUser) => {
    if (!currentUser) return null;
    return currentUser.attributes?.profile?.protectedData?.userType === userTypes.shopper
}

export const getIsShopsAndBrands = (currentUser) => {
    if (!currentUser) return null;
    return currentUser.attributes?.profile?.protectedData?.userType === userTypes.shopsAndBrands
        || currentUser.attributes?.profile?.protectedData?.userType === userTypes.shopsAndBrandsAndShopper;
}

export const getUserType = (currentUser) => {
    if (!currentUser) return null;
    return currentUser.attributes?.profile?.protectedData?.userType;
}

export const getIsApproved = (currentUser) => {
    if (!currentUser) return null;
    return currentUser.attributes?.profile?.protectedData?.isApproved === true;
}